import React from 'react';
import { Badge, Box, IconButton, Tooltip, useDisclosure } from '@chakra-ui/react';
import { FaBullhorn } from 'react-icons/fa';

import NovedadesWamPanel from './NovedadesWamPanel';
import { useNovedadesResumen } from './useNovedadesWam';

/** Megáfono del header con la cantidad de novedades sin leer. */
const NovedadesWamBoton = () => {
  const panel = useDisclosure();
  const { data } = useNovedadesResumen();
  const noLeidas = data?.no_leidas || 0;

  return (
    <Box position="relative">
      <Tooltip hasArrow label="Novedades de WAM">
        <IconButton
          aria-label={noLeidas > 0 ? `Novedades de WAM: ${noLeidas} sin leer` : 'Novedades de WAM'}
          icon={<FaBullhorn />}
          variant="ghost"
          borderRadius="full"
          onClick={panel.onOpen}
        />
      </Tooltip>
      {noLeidas > 0 && (
        <Badge
          colorScheme="green"
          borderRadius="full"
          position="absolute"
          top="-2px"
          right="-2px"
          fontSize="0.6rem"
          px={1}
          pointerEvents="none"
        >
          {noLeidas > 99 ? '99+' : noLeidas}
        </Badge>
      )}
      <NovedadesWamPanel isOpen={panel.isOpen} onClose={panel.onClose} />
    </Box>
  );
};

export default NovedadesWamBoton;
